<classy-layout *ngIf="layout === 'classy'"></classy-layout>
<div *ngIf="layout === 'empty'">
  <og-floating-labels></og-floating-labels>

  <fuse-loading-bar></fuse-loading-bar>
  <router-outlet></router-outlet>
</div>
